<template>
  <div>
    <footer>
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-6">
            <h3 data-target="#collapse_1">Khám phá</h3>
            <div class="collapse dont-collapse-sm links" id="collapse_1">
              <ul>
                <li><a href="https://merchant.monmi.vn">Chủ nhà hàng</a></li>
                <li>
                  <router-link :to="{ path: 'terms-of-use' }">Điều khoản & Điều kiện</router-link>
                </li>
                <li>
                  <router-link :to="{ path: 'policy' }">Chính sách bảo mật</router-link>
                </li>
                <li><a href="">Liên hệ</a></li>
              </ul>
            </div>
            <div class="img-apple-store">
              <a href="#">
                <img src="@/assets/logo-appstore.svg" alt="Apple Store">
              </a>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <h3 data-target="#collapse_2">Danh mục sản phẩm</h3>
            <div class="collapse dont-collapse-sm links" id="collapse_2">
              <ul>
                <li><a href="">Top bán chạy</a></li>
                <li><a href="">Ưu đãi</a></li>
                <li><a href="">Khuyến mại hôm nay</a></li>
                <li><a href=""></a></li>
              </ul>
            </div>
            <div class="img-apple-store">
              <a href="https://play.google.com/store/apps/details?id=com.monmi.vn">
                <img src="@/assets/logo-playstore.svg" alt="Play Store">
              </a>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <h3 data-target="#collapse_3">Thông tin liên hệ</h3>
            <div class="collapse dont-collapse-sm contacts" id="collapse_3">
              <ul>
                <li><i class="icon_house_alt"></i>Công Ty Trách Nhiệm Hữu Hạn EPIS Việt Nam</li>
                <li><i class="icon_house_alt"></i>251 Trần Quang Khải, Phường Tân Định, Quận 1</li>
                <li><i class="icon_house_alt"></i>Giấy chứng nhận đăng ký doanh nghiệp số: 0316494549 do Sở Kế hoạch và Đầu tư thành phố Hồ Chí Minh cấp ngày 24/09/2020 </li>
                <li><i class="icon_mobile"></i>+84 249 998 2323	</li>
                <li><i class="icon_mail_alt"></i><a href="">info@monmi.vn</a></li>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <h3 data-target="#collapse_4">Phản hồi</h3>
            <div class="collapse dont-collapse-sm" id="collapse_4">
              <div id="newsletter">
                <div id="message-newsletter"></div>
                <form method="post" action="assets/newsletter.php" name="newsletter_form" id="newsletter_form">
                  <div class="form-group">
                    <input type="email" name="email_newsletter" id="email_newsletter" class="form-control" placeholder="Your email">
                    <button type="submit" id="submit-newsletter"><i class="arrow_carrot-right"></i></button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- /row-->
        <hr>
        <div class="row add_bottom_25">
          <div class="col-lg-6">
            <ul class="footer-selector clearfix">
              <li>
                <div class="styled-select lang-selector">
                  <select>
                    <option value="Vietnamese" selected>Tiếng Việt</option>
                  </select>
                </div>
              </li>
              <li>
                <div class="styled-select currency-selector">
                  <select>
                    <option value="VNĐ" selected>VNĐ</option>
<!--                    <option value="Euro">Euro</option>-->
                  </select>
                </div>
              </li>
              <li><img src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" data-src="/static/images/cards_all.svg" alt="" width="198" height="30" class="lazy"></li>
            </ul>
          </div>
          <div class="col-lg-6">
            <ul class="additional_links">
              <li>
                <router-link :to="{ path: 'terms-of-use' }">Điều khoản sử dụng</router-link>
              </li>
<!--              <li><a href="https://epis.vn/policy">Privacy</a></li>-->
              <li><span>© Monmi</span></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
    <div id="toTop"></div><!-- Back to top button -->

    <div class="layer"></div><!-- Opacity Mask Menu Mobile -->

    <!-- Sign In Modal -->
    <div id="sign-in-dialog" class="zoom-anim-dialog mfp-hide">
      <div class="modal_header">
        <h3>Đăng Nhập</h3>
      </div>
      <form>
        <div class="sign-in-wrapper">
<!--          <a href="#0" class="social_bt facebook">Login with Facebook</a>-->
<!--          <a href="#0" class="social_bt google">Login with Google</a>-->
<!--          <div class="divider"><span>Or</span></div>-->
          <div class="form-group">
            <label>Email</label>
            <input type="email" class="form-control" name="email" id="email">
            <i class="icon_mail_alt"></i>
          </div>
          <div class="form-group">
            <label>Mật khẩu</label>
            <input type="password" class="form-control" name="password" id="password" value="">
            <i class="icon_lock_alt"></i>
          </div>
          <div class="clearfix add_bottom_15">
            <div class="checkboxes float-left">
              <label class="container_check">Nhớ mật khẩu
                <input type="checkbox">
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="float-right mt-1"><a id="forgot" href="javascript:void(0);">Quên mật khẩu?</a></div>
          </div>
          <div class="text-center">
            <input type="submit" value="Đăng Nhập" class="btn_1 full-width mb_5">
            Bạn chưa có tài khoản?
            <router-link to="/register">
              Đăng Ký
            </router-link>
          </div>
          <div id="forgot_pw">
            <div class="form-group">
              <label>Please confirm login email below</label>
              <input type="email" class="form-control" name="email_forgot" id="email_forgot">
              <i class="icon_mail_alt"></i>
            </div>
            <p>You will receive an email containing a link allowing you to reset your password to a new preferred one.</p>
            <div class="text-center"><input type="submit" value="Reset Password" class="btn_1"></div>
          </div>
        </div>
      </form>
      <!--form -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Foot"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Foot.vue